import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

// O estado do template do código de verificação: qual está vinculado e o que a Meta
// exige para liberar a categoria Autenticação. Lido pelo cartão de Templates e pelo
// formulário de criação, que não oferece a categoria enquanto ela está travada.

interface Tpl { id: string; name: string; language: string; category: string; status: string; variables: number }

export interface OTPInfo {
  template: Tpl | null;
  eligibility: {
    business_verification: string; owner_business_name?: string; messaging_limit: string; required_limit: string;
    verification_ok: boolean; limit_ok: boolean; approved_auth_templates: number;
  };
}

/**
 * A Meta liberou a categoria Autenticação nesta conta? Exige as DUAS coisas: o portfólio
 * dono da conta verificado e o número em 2.000 contatos novos por dia (TIER_2K). Em
 * 24/10/2026 tiramos o limite achando que bastava a verificação — e a Meta recusou o
 * template (subcode 2388185) numa conta com portfólio verificado em TIER_250. Também
 * libera com um template de autenticação já aprovado; verificação que não deu para
 * consultar agora não trava (impediria quem já está liberado).
 */
export function otpReleased(el: OTPInfo['eligibility'] | undefined): boolean {
  if (!el) return true;
  if (el.approved_auth_templates > 0) return true;
  const verifyKnown = !!el.business_verification && el.business_verification !== 'unknown';
  return el.limit_ok && (el.verification_ok || !verifyKnown);
}

/** O estado do template do código (vínculo + exigências da Meta), compartilhado com o formulário. */
export function useOTPInfo() {
  return useQuery({
    queryKey: ['templates', 'otp'],
    queryFn: async (): Promise<OTPInfo | null> => {
      const r = await apiFetch('GET', '/templates/otp');
      return r.ok ? (r.data as OTPInfo) : null;
    },
  });
}

